
<div class="header-toolbar">
  <h1>{{ title }}</h1>
</div>

<div *ngIf="execution">

  <!-- Toolbar -->
  <div class="main btn-toolbar">

    <div class="btn-group">
      <div class="content">

        <button class="btn" (click)="save()" [disabled]="!selectedDossier || !selectedLinks || selectedLinks.length === 0 || execution.dossiers.length === 0">
          <t-icon name="check"></t-icon>
          <span class="text">Confirmer</span>
        </button>
        
        <button class="btn" (click)="applyFilter()">
          <t-icon name="search"></t-icon>
          <span class="text">Filtrer les dossiers</span>
        </button>

      </div>
    </div>
  </div>
  <!-- /Toolbar -->

  <div class="grid">

    <div class="column">

      <t-select-dossier [(selectedDossier)]="selectedDossier" [(showFilter)]="showDossierFilter"></t-select-dossier>
      
    </div>

    <div class="column">

      <div class="panel" *ngIf="!selectedDossier">
        <div class="empty-table compact">
          <p>Veuillez sélectionner un dossier</p>
        </div>
      </div>

      <div class="panel" *ngIf="selectedDossier">
        <h2>
          Données
          <span style="font-size: 14px; color: #383838;" *ngIf="selectedLinks">
            ({{ selectedLinks.length }} enregistrements sélectionnés)
          </span>
        </h2>

        <t-select-tree [dossier]="selectedDossier" [dossierModel]="dossierModel" [(selectedLinks)]="selectedLinks"></t-select-tree>

      </div>

      <t-select-root-fields *ngIf="selectedDossier" [operation]="operation" [revision]="operation.revision" (selected)="onSelectedRootFields($event)"></t-select-root-fields>

    </div>

  </div>
</div>